import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeSlug from 'rehype-slug';
import { Container, Link as MuiLink } from '@mui/material';
import { ScrollToTopButton } from '@features/scroll-to-top-button';

const scrollToHash = () => {
    const hash = decodeURIComponent(window.location.hash.substring(1)); // Убираем #
    if (hash) {
        const el = document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
};

const MarkdownRenderer = ({ filePath }) => {
    const [markdown, setMarkdown] = useState('');

    useEffect(() => {
        fetch(filePath)
            .then((response) => response.text())
            .then((text) => setMarkdown(text));
    }, [filePath]);

    useEffect(() => {
        window.addEventListener('hashchange', scrollToHash);
        return () => window.removeEventListener('hashchange', scrollToHash);
    }, []);

    return (
        <div className="markdown-container">
            <ReactMarkdown
                rehypePlugins={[rehypeSlug]}
                components={{
                    img: ({ src, alt }) => (
                        <img
                            src={src}
                            alt={alt}
                            style={{
                                maxWidth: '100%',
                                height: 'auto',
                                display: 'block',
                                margin: '0 auto',
                                borderRadius: '8px',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                            }}
                        />
                    ),
                    a: ({ href, children }) => (
                        <MuiLink
                            href={href}
                            // target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                                color: '#015901',
                                textDecoration: 'none',
                                fontWeight: 'bold',
                                '&:hover': {
                                    textDecoration: 'underline',
                                    color: '#01422a'
                                }
                            }}
                        >
                            {children}
                        </MuiLink>
                    )
                }}
            >
                {markdown}
            </ReactMarkdown>
        </div>
    );
};

export const DocumentationPage = () => {
    return (
        <Container
            sx={{
                width: '100%',
                padding: 2,
                height: 'auto', // Избегайте фиксированной высоты
                overflow: 'visible'
            }}
        >
            <MarkdownRenderer filePath="/documents/readme.md"/>
            <ScrollToTopButton containerId="main"/>
        </Container>
    );
};
